import JSEncrypt from "jsencrypt";

export default {
    encodeRSA(word, keyStr) {
        //这个是公钥,有入参时用入参，没有入参用默认公钥
        keyStr = keyStr ? keyStr : 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCRWYjsJBs7SPkTzwfAVLZT3/am6FaV99aFtEmsc7rrHS7ITpGj8TRv//0Ah6E10uudUI2mAis0L7o52CZ+0+4qTatlDtlbDXgraw4vcduwFuBU70Qx8DJf3adA6G6wi845+0m98fBRTtQGgEhr+3z5KmSFIdIwnAq4NmaZ+AuNnQIDAQAB';
        //创建对象
        const jsRsa = new JSEncrypt();
        //设置公钥
        jsRsa.setPublicKey(keyStr);
        //返回加密后结果
        return jsRsa.encrypt(word);
    }
}